<script>
    export default {
        props: ['item', 'prop', 'selectItems', 'itemType', 'title'],
        data() {
            return {
               availableItems: []
            }
        },
        created() {
            this.setSelectItems();
        },
        methods: {
            selectItem(item) {
                const index = this.item[this.prop].indexOf(item.id);
                if (index === -1) {
                    this.item[this.prop].push(item.id);  // add
                } else {
                    this.item[this.prop].splice(index, 1); // remove
                }
            },
            setSelectItems() {
                if(this.itemType == 'workGroups')           
                { 
                    var self = this;   
                    this.availableItems = this.$store.state.workGroups                  
                        .map(function(item) {
                            return {id: item.id, name: item.name, selected: self.selected_ids.some(x => x == item.id) }
                        });
                }
                else {
                    this.availableItems = this.selectItems;
                }
            }                
        },
        computed:
        {
            selected_ids() { return this.item[this.prop] }
        }
    }
</script>

<template>
    <div class="row">
        <div class="g-100">   
            <button v-for="item in availableItems" class="btn" @click="selectItem(item)" :class="!selected_ids.includes(item.id) ? 'btn-gray': ''">
                {{ item.name }}
            </button>          
        </div>        
    </div>
</template>
    
<style scoped>

</style>